import React from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setMenu,setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import FileUploader from '../components/FileUploader';
import $ from 'jquery';

class EditClient extends BasePage {

    loadOnConstructor(){
	this.getClient = this.getClient.bind(this);
	this.cancelButton = this.cancelButton.bind(this);
	this.saveButton = this.saveButton.bind(this);
	this.updateClientCallback = this.updateClientCallback.bind(this);
	this.newClientCallback = this.newClientCallback.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.renderContactModes = this.renderContactModes.bind(this);
	this.addContactMode = this.addContactMode.bind(this);
	this.deleteContactMode = this.deleteContactMode.bind(this);
	this.altTab = this.altTab.bind(this);
	this.openScheduleCard = this.openScheduleCard.bind(this);
	this.openScheduleInfo = this.openScheduleInfo.bind(this);
	this.renderEditSchedule = this.renderEditSchedule.bind(this);
	this.changeScheduleCallback = this.changeScheduleCallback.bind(this);
	this.determineAction = this.determineAction.bind(this);
	this.sendUploadFile = this.sendUploadFile.bind(this);

	this.showAddFileWindow = this.showAddFileWindow.bind(this);
	this.downloadFile = this.downloadFile.bind(this);
	this.downloadFileCallback = this.downloadFileCallback.bind(this);
	this.deleteFile = this.deleteFile.bind(this);
	this.deleteFileConfirmed = this.deleteFileConfirmed.bind(this);
	this.deleteFileCallback = this.deleteFileCallback.bind(this);
	this.openBill = this.openBill.bind(this);
	this.openArticle = this.openArticle.bind(this);

	this.uploadFile = React.createRef();

	this.determineAction();
    }

    determineAction(){
	const {client_id} = this.getUrlParams();
	if(client_id !== undefined){
		this.state = {action: 'modify', client_id: client_id};
		this.getClient(client_id);
	}else{
		this.state = {action: 'new', isSaving: false};
		this.getClient();
	}

    }

    getClient(clientId){
	const api = this.getApi();
	api.getEditClientInterface(clientId, (response) => {

		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		for(let prop in response.client){
			if(response.client[prop] === 'null') response.client[prop] = '';
		}

		response.schedules.map(schedule => {

			const date = new Date(schedule.start_date);
			const dateString =
			("0" + date.getUTCDate()).slice(-2) + "/" +
			("0" + (date.getUTCMonth()+1)).slice(-2) + "/" +
			date.getUTCFullYear() + " " +
			("0" + date.getUTCHours()).slice(-2) + ":" +
			("0" + date.getUTCMinutes()).slice(-2);
			
			schedule.formatted_start_date = dateString;
			return schedule;
		});

		this.setState(prevState => {
			return {
			...prevState,
			client: response.client,
			locations: response.locations || [],
			i18n: response.i18n,
			schedules: response.schedules,
			bills: response.bills || [],
			articles: response.articles || [],
			files: response.files || []
		}});
	});
    }

    cancelButton(){
	this.goBack();
    }

    saveButton(){

	let failedValidators = {};
	if($('#name').val() === ''){
		failedValidators.name = this.getTrad('fillNameField');
	}

	if($('#mobile_0').length === 0 && $('#landline_0').length === 0 && $('#email_0').length === 0){
		failedValidators.contactModes = this.getTrad('fillContactMode');
	}
	if(Object.keys(failedValidators).length !== 0){
		let message = [];
		for (let m in failedValidators){
			message.push(failedValidators[m]);
		}
		this.props.setModalContent({
			title: this.getTrad('fillAllMandatoryFields'),
			body: message,
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

		$("#exampleModal").modal('toggle');
		return;
	}

	let prevState = JSON.parse(JSON.stringify(this.state.client));

	if(prevState.mobile && prevState.mobile.length > 0){
		for(const mob of prevState.mobile){
			if(!(""+mob).match(/^\+?[0-9]{9,}$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.mobile = prevState.mobile.join();
	}else{
		prevState.mobile = [];
	}

	if(prevState.landline && prevState.landline.length > 0){
		for(const land of prevState.landline){
			if(!(""+land).match(/^\+?[0-9]{9,}$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.landline = prevState.landline.join();
	}else{
		prevState.landline = [];
	}

	if(prevState.email && prevState.email.length > 0){
		for(const em of prevState.email){
			if(!em.match(/^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.email = prevState.email.join();
	}else{
		prevState.email = [];
	}

	this.setState({ isSaving: true })
	const api = this.getApi();

	if(this.state.action === 'modify'){
	    	api.updateClient(prevState,this.updateClientCallback);
	}else{
	    	api.newClient(prevState,this.newClientCallback);
	}

	let clientPreviousState = prevState;

	clientPreviousState.mobile = clientPreviousState.mobile? clientPreviousState.mobile.split(","):[];
	clientPreviousState.landline = clientPreviousState.landline? clientPreviousState.landline.split(","):[];
	clientPreviousState.email = clientPreviousState.email? clientPreviousState.email.split(","):[];

	this.setState(prevState => {
		return {
			...prevState,
			client: clientPreviousState
		}
	});
    }

    updateClientCallback(response){
		this.setState({ isSaving: false })
    	if(response.status === 'OK'){
    	this.props.setModalContent({
		title: this.getTrad('messageFromServer'),
		body: [this.getTrad('clientModifiedSuccessfully')],
		buttons: [
			{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
		]
	});

	$("#exampleModal").modal('toggle');
	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}
    }

    newClientCallback(response){
		this.setState({ isSaving: false })
	if(response.status !== 'OK'){

		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad("clientSavedSuccessfully")],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('clientCreatedSuccessfully')],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');
	}
    }

    addContactMode(mode){
    	let clientMod = {};
    	if(this.state.client){
		clientMod = this.state.client;
	}

	if(!clientMod[mode]){
		clientMod[mode] = [];
	}

	clientMod[mode].push("");
	
	this.setState(prevState => {
		return {
			...prevState,
			client: clientMod
		}
	});
    }

    deleteContactMode(contactMode, id){

	let clientMod = {...this.state.client};
	const newModes = clientMod[contactMode].filter((element, idx) =>  idx !== id);

	clientMod[contactMode] = newModes
	
	this.setState(prevState => {
		return {
			...prevState,
			client: clientMod
		}
	});
    }

    handleChange(event) {
	let clientMod = {...this.state.client};
	if(event.target.name.match(/mobile/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^\+?[0-9]{9,}$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}

		if(clientMod.mobile[parts[1]] !== undefined){
			clientMod.mobile[parts[1]] = event.target.value;
		}else{
			clientMod.mobile.push(event.target.value);
		}
	}else if(event.target.name.match(/landline/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^\+?[0-9]{9,}$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}


		if(clientMod.landline[parts[1]] !== undefined){
			clientMod.landline[parts[1]] = event.target.value;
		}else{
			clientMod.landline.push(event.target.value);
		}

	}else if(event.target.name.match(/email/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}

		if(clientMod.email[parts[1]] !== undefined){
			clientMod.email[parts[1]] = event.target.value;
		}else{
			clientMod.email.push(event.target.value);
		}

	}else if(event.target.name === 'status'){

		let schMod = this.state.scheduleSelected;
		schMod.status = event.target.value;
		this.setState(prevState => {
			return {
			...prevState,
			scheduleSelected: schMod
		}});
	}else if(event.target.type === 'checkbox'){
		clientMod[event.target.name] = event.target.checked;
	}else{
		clientMod[event.target.name] = event.target.value;
	}

	this.setState(prevState => {
		return {
		...prevState,
		client: clientMod
	}});
    }

    renderContactModeBlock(contactMode, contactModeArray){
    	    return contactModeArray && contactModeArray.length>0 && contactModeArray.map?contactModeArray.map((elem,idx) => {
		return <div className="row" key={"row_contact_mode_"+idx+"_"+elem}>
			<div className="col-4">
				<div className="form-group">
					<input type={contactMode === 'email'?contactMode:'text'} className="form-control" 
					id={contactMode+"_"+idx} name={contactMode+"_"+idx}
					    defaultValue={this.state.client?elem:''} onBlur={this.handleChange}/>
				</div>
			</div>
			<div className="col-4">
				  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary ml-2" 
					  onClick={() => {this.deleteContactMode(contactMode, idx)}}>-</button>
				  </div>
			</div>
		</div>

	}):""
    }

    renderContactModes(){
	    return (
	    	<>
	    	<div className="row">
	    		<div className="col-3">{this.getTrad("mobiles")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('mobile')}}>+</button>
				  </div>
	    		</div>
	    	</div>
		{this.renderContactModeBlock("mobile", this.state.client?this.state.client.mobile:[])}
	    	<div className="row">
	    		<div className="col-3">{this.getTrad("landlines")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('landline')}}>+</button>
				  </div>
	    		</div>
	    	</div>

		{this.renderContactModeBlock("landline", this.state.client?this.state.client.landline:[])}
	  	<div className="row">
	    		<div className="col-3">{this.getTrad("emails")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('email')}}>+</button>
				  </div>
	    		</div>
	    	</div>
		{this.renderContactModeBlock("email", this.state.client?this.state.client.email:[])}
	    	</>   
	    )
    }

    altTab(tabId){
	const tabs = ['principal', 'citas','ficheros', 'facturas', 'articulos'];

	for (let tab in tabs){
		$('#'+tabs[tab]).css("display", "none");
		$('#'+tabs[tab]+"Tab").removeClass("active");
	}

	$('#'+tabId).css("display", "block");
	$('#'+tabId+"Tab").addClass("active");
	//aria-current="page"
    }

    openScheduleCard(arrayPosition){
	const schedule = this.state.schedules[arrayPosition];

	this.setState(prevState => {
		return {
			...prevState,
			scheduleSelected: schedule
		}
	},
	this.openScheduleInfo);

    }

    openScheduleInfo(){
	    $("#editSchedule").modal('toggle');
    }

    changeScheduleCallback(response){
	if(response.status === 'OK'){
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('ScheduleModifiedSuccessfully')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

		$("#exampleModal").modal('toggle');

		//Reload schedules from server
		this.determineAction();
	}
    }

    formatDateToUserString(dateString){
console.log(dateString, typeof dateString)
	return dateString.substring(8,10)+'/'+dateString.substring(5,7)+'/'+dateString.substring(0,4)+' '+
	    	dateString.substring(11,13)+':'+dateString.substring(14,16);
    }

    renderEditSchedule(){
    	    const sch = this.state.scheduleSelected;

	return (<div className="row">
		<div className="col-12">
			<form>
				<div className="form-group">
					<label htmlFor="title">{this.getTrad("scheduleTitle")}</label>
					<input type="text" className="form-control" id="title" name="title"
					defaultValue={sch?sch.title:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="start_date">{this.getTrad("startDate")}</label>
					<input type="text" className="form-control" id="start_date" name="start_date"
					defaultValue={sch?this.formatDateToUserString(sch.start_date):''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="end_date">{this.getTrad("endDate")}</label>
					<input type="text" className="form-control" id="end_date" name="end_date"
					defaultValue={sch?this.formatDateToUserString(sch.end_date):''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="assigned_user">{this.getTrad("user")}</label>
					<input type="text" className="form-control" id="assigned_user" name="assigned_user"
					defaultValue={sch?sch.assigned_user.name+' '+sch.assigned_user.lastname:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="comments">{this.getTrad("description")}</label>
					<textarea className="form-control" id="comments" name="description"
					defaultValue={sch?sch.description:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="status">{this.getTrad("scheduleStatus")}</label>
					<select className="form-control" id="status" name="status"
					defaultValue={sch?sch.status:''} onChange={this.handleChange}>
						<option value="1" selected={sch && sch.status === 1?true:undefined} >
							{this.getTrad("planned")}
						</option>
						<option value="2" selected={sch && sch.status === 2?true:undefined}>
							{this.getTrad("reportedFinished")}
						</option>
						<option value="3" selected={sch && sch.status === 3?true:undefined}>
							{this.getTrad("reportedCanceled")}
						</option>
					</select>
				</div>
			</form>
		</div>
    	</div>)
    }


    showAddFileWindow(){
	this.props.setModalContent({
	    title: this.getTrad('addFile'),
	    body: [
	    	(<FileUploader ref={this.uploadFile}  onSendFile={this.sendUploadFile} aditionalFields={[{name: 'client', value: this.state.client_id }]} />)
	    ],
	    buttons: [
		    {shown: 'Aceptar', behaviour: 'main', callback:() => {this.uploadFile.current.sendForm()}, close: true},
		    {shown: 'Cancelar', close: true}
	    ]
	});

	$("#exampleModal").modal('toggle');
    }

    sendUploadFile(response){
	if(response.status === 'OK'){

	    let currFiles = JSON.parse(JSON.stringify(this.state.files)); 
	    currFiles.unshift(response.file);

	    this.setState(prevState => {
		return {
		    ...prevState,
		    files: currFiles
		}
	    });
	}
	
    }

    downloadFile(fileId){
	const api = this.getApi();

	this.setState(prevState => {
		return {
			...prevState,
		    	downloadFile: this.state.files.filter(file => file._id === fileId).pop()
		}
	},api.downloadFile(fileId, this.downloadFileCallback));
    }

    downloadFileCallback(response){

		const newBlob = new Blob([response], { type: 'application/octet-stream' });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            		window.navigator.msSaveOrOpenBlob(newBlob);
       		} else {
            		// For other browsers: create a link pointing to the ObjectURL containing the blob.
            		const objUrl = window.URL.createObjectURL(newBlob);

            		let link = document.createElement('a');
            		link.href = objUrl;
            		link.download = this.state.downloadFile.name;
            		link.click();

            		// For Firefox it is necessary to delay revoking the ObjectURL.
            		setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
        	}

		this.setState(prevState => {
			return {
				...prevState,
				downloadFile: undefined
			}
		});
    }

	openBill(billId){
		this.navigateTo('/edit_bill?bill_id='+billId)
	}

	openArticle(articleId){
		this.navigateTo('/edit_article?article_id='+articleId)
	}

    deleteFile(fileId){
	this.props.setModalContent({
	    title: this.getTrad('deleteFile'),
	    body: [this.getTrad('AreYouSureYouWantToDeleteFile')],
	    buttons: [
	    {shown: 'Aceptar', behaviour: 'main', close: true, callback: () => {this.deleteFileConfirmed(fileId)}},
	    {shown: 'Cancelar', close: true}
	    ]
	});

	$("#exampleModal").modal('toggle');
    }

    deleteFileConfirmed(fileId){
    	const api = this.getApi();
    	this.setState(prevState => {
		return {
			...prevState,
		    	fileToRemove: fileId
		}
	},api.deleteFile(fileId, this.deleteFileCallback));
    }

    deleteFileCallback(response){
	let currFiles = JSON.parse(JSON.stringify(this.state.files)); 

	if(response.status === 'OK'){
		this.setState(prevState => {
			return {
				...prevState,
			    	files: currFiles.filter(file => {
					return file._id !== this.state.fileToRemove
				})
			}
		});
	}
    }



	dateToString(dateObject, returnObject){
		const multiplier = 1
		const hoursFromTimezoneOffset = (dateObject.getTimezoneOffset() * multiplier) / 60;
		let dateToString = new Date(dateObject.getTime());
		dateToString.setHours(dateObject.getHours() + hoursFromTimezoneOffset);
	
		return returnObject?dateToString:dateToString.toISOString()
	}

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('clientEdition')}</h3>
		<ul className="nav nav-tabs">
			<li className="nav-item">
				<a id="principalTab" className="nav-link active" aria-current="page" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('principal') }}>
					Principal
				</a>
			</li>
			{this.state.action !== 'new'?
			<>
			<li className="nav-item">
				<a id="citasTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('citas')}}>
					Citas
				</a>
			</li>
			<li className="nav-item">
				<a id="ficherosTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('ficheros')}}>
					Ficheros
				</a>
			</li>
			<li className="nav-item">
				<a id="facturasTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('facturas')}}>
					Facturas
				</a>
			</li>
			<li className="nav-item">
				<a id="articulosTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('articulos')}}>
					Artículos
				</a>
			</li>
			</>:undefined}
		</ul>

		{/*Comienzo tab Principal*/}
                <div className="row mt-4" id="principal" style={{display:'block'}}>
			<div className="col-12">
				<form>
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.client?this.state.client.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="lastname">Apellidos</label>
				    <input type="text" className="form-control" id="lastname" name="lastname"
				    defaultValue={this.state.client?this.state.client.lastname:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="dni">DNI/NIF/Pasaporte</label>
				    <input type="text" className="form-control" id="dni" name="dni"
				    defaultValue={this.state.client?this.state.client.dni:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group form-check mt-1 mb-2">
				    <input type="checkbox" className="form-check-input" id="foreign_passport" name="foreign_passport"
				    checked={this.state.client?.foreign_passport || false} onChange={this.handleChange} />
				    <label className="form-check-label" htmlFor="foreign_passport">Pasaporte extranjero (no NIF español)</label>
				  </div>
				  {this.state.client?.foreign_passport && (
				    <div className="form-group mb-3">
				      <label htmlFor="country_code">País emisor del documento <span style={{color:'#dc3545'}}>*</span></label>
				      <select className="form-control" id="country_code" name="country_code"
				        value={this.state.client?.country_code || ''}
				        onChange={this.handleChange}>
				        <option value="">— Selecciona un país —</option>
				        <option value="AD">AD — Andorra</option>
				        <option value="AE">AE — Emiratos Árabes Unidos</option>
				        <option value="AF">AF — Afganistán</option>
				        <option value="AG">AG — Antigua y Barbuda</option>
				        <option value="AL">AL — Albania</option>
				        <option value="AM">AM — Armenia</option>
				        <option value="AO">AO — Angola</option>
				        <option value="AR">AR — Argentina</option>
				        <option value="AT">AT — Austria</option>
				        <option value="AU">AU — Australia</option>
				        <option value="AZ">AZ — Azerbaiyán</option>
				        <option value="BA">BA — Bosnia y Herzegovina</option>
				        <option value="BB">BB — Barbados</option>
				        <option value="BD">BD — Bangladés</option>
				        <option value="BE">BE — Bélgica</option>
				        <option value="BF">BF — Burkina Faso</option>
				        <option value="BG">BG — Bulgaria</option>
				        <option value="BH">BH — Baréin</option>
				        <option value="BI">BI — Burundi</option>
				        <option value="BJ">BJ — Benín</option>
				        <option value="BN">BN — Brunéi</option>
				        <option value="BO">BO — Bolivia</option>
				        <option value="BR">BR — Brasil</option>
				        <option value="BS">BS — Bahamas</option>
				        <option value="BT">BT — Bután</option>
				        <option value="BW">BW — Botsuana</option>
				        <option value="BY">BY — Bielorrusia</option>
				        <option value="BZ">BZ — Belice</option>
				        <option value="CA">CA — Canadá</option>
				        <option value="CD">CD — R. D. del Congo</option>
				        <option value="CF">CF — R. Centroafricana</option>
				        <option value="CG">CG — República del Congo</option>
				        <option value="CH">CH — Suiza</option>
				        <option value="CI">CI — Costa de Marfil</option>
				        <option value="CL">CL — Chile</option>
				        <option value="CM">CM — Camerún</option>
				        <option value="CN">CN — China</option>
				        <option value="CO">CO — Colombia</option>
				        <option value="CR">CR — Costa Rica</option>
				        <option value="CU">CU — Cuba</option>
				        <option value="CV">CV — Cabo Verde</option>
				        <option value="CY">CY — Chipre</option>
				        <option value="CZ">CZ — República Checa</option>
				        <option value="DE">DE — Alemania</option>
				        <option value="DJ">DJ — Yibuti</option>
				        <option value="DK">DK — Dinamarca</option>
				        <option value="DM">DM — Dominica</option>
				        <option value="DO">DO — República Dominicana</option>
				        <option value="DZ">DZ — Argelia</option>
				        <option value="EC">EC — Ecuador</option>
				        <option value="EE">EE — Estonia</option>
				        <option value="EG">EG — Egipto</option>
				        <option value="ER">ER — Eritrea</option>
				        <option value="ET">ET — Etiopía</option>
				        <option value="FI">FI — Finlandia</option>
				        <option value="FJ">FJ — Fiyi</option>
				        <option value="FR">FR — Francia</option>
				        <option value="GA">GA — Gabón</option>
				        <option value="GB">GB — Reino Unido</option>
				        <option value="GD">GD — Granada</option>
				        <option value="GE">GE — Georgia</option>
				        <option value="GH">GH — Ghana</option>
				        <option value="GM">GM — Gambia</option>
				        <option value="GN">GN — Guinea</option>
				        <option value="GQ">GQ — Guinea Ecuatorial</option>
				        <option value="GR">GR — Grecia</option>
				        <option value="GT">GT — Guatemala</option>
				        <option value="GW">GW — Guinea-Bisáu</option>
				        <option value="GY">GY — Guyana</option>
				        <option value="HN">HN — Honduras</option>
				        <option value="HR">HR — Croacia</option>
				        <option value="HT">HT — Haití</option>
				        <option value="HU">HU — Hungría</option>
				        <option value="ID">ID — Indonesia</option>
				        <option value="IE">IE — Irlanda</option>
				        <option value="IL">IL — Israel</option>
				        <option value="IN">IN — India</option>
				        <option value="IQ">IQ — Irak</option>
				        <option value="IR">IR — Irán</option>
				        <option value="IS">IS — Islandia</option>
				        <option value="IT">IT — Italia</option>
				        <option value="JM">JM — Jamaica</option>
				        <option value="JO">JO — Jordania</option>
				        <option value="JP">JP — Japón</option>
				        <option value="KE">KE — Kenia</option>
				        <option value="KG">KG — Kirguistán</option>
				        <option value="KH">KH — Camboya</option>
				        <option value="KI">KI — Kiribati</option>
				        <option value="KM">KM — Comoras</option>
				        <option value="KN">KN — San Cristóbal y Nieves</option>
				        <option value="KP">KP — Corea del Norte</option>
				        <option value="KR">KR — Corea del Sur</option>
				        <option value="KW">KW — Kuwait</option>
				        <option value="KZ">KZ — Kazajistán</option>
				        <option value="LA">LA — Laos</option>
				        <option value="LB">LB — Líbano</option>
				        <option value="LC">LC — Santa Lucía</option>
				        <option value="LI">LI — Liechtenstein</option>
				        <option value="LK">LK — Sri Lanka</option>
				        <option value="LR">LR — Liberia</option>
				        <option value="LS">LS — Lesoto</option>
				        <option value="LT">LT — Lituania</option>
				        <option value="LU">LU — Luxemburgo</option>
				        <option value="LV">LV — Letonia</option>
				        <option value="LY">LY — Libia</option>
				        <option value="MA">MA — Marruecos</option>
				        <option value="MC">MC — Mónaco</option>
				        <option value="MD">MD — Moldavia</option>
				        <option value="ME">ME — Montenegro</option>
				        <option value="MG">MG — Madagascar</option>
				        <option value="MH">MH — Islas Marshall</option>
				        <option value="MK">MK — Macedonia del Norte</option>
				        <option value="ML">ML — Malí</option>
				        <option value="MM">MM — Myanmar</option>
				        <option value="MN">MN — Mongolia</option>
				        <option value="MR">MR — Mauritania</option>
				        <option value="MT">MT — Malta</option>
				        <option value="MU">MU — Mauricio</option>
				        <option value="MV">MV — Maldivas</option>
				        <option value="MW">MW — Malaui</option>
				        <option value="MX">MX — México</option>
				        <option value="MY">MY — Malasia</option>
				        <option value="MZ">MZ — Mozambique</option>
				        <option value="NA">NA — Namibia</option>
				        <option value="NE">NE — Níger</option>
				        <option value="NG">NG — Nigeria</option>
				        <option value="NI">NI — Nicaragua</option>
				        <option value="NL">NL — Países Bajos</option>
				        <option value="NO">NO — Noruega</option>
				        <option value="NP">NP — Nepal</option>
				        <option value="NR">NR — Nauru</option>
				        <option value="NZ">NZ — Nueva Zelanda</option>
				        <option value="OM">OM — Omán</option>
				        <option value="PA">PA — Panamá</option>
				        <option value="PE">PE — Perú</option>
				        <option value="PG">PG — Papúa Nueva Guinea</option>
				        <option value="PH">PH — Filipinas</option>
				        <option value="PK">PK — Pakistán</option>
				        <option value="PL">PL — Polonia</option>
				        <option value="PT">PT — Portugal</option>
				        <option value="PW">PW — Palaos</option>
				        <option value="PY">PY — Paraguay</option>
				        <option value="QA">QA — Catar</option>
				        <option value="RO">RO — Rumanía</option>
				        <option value="RS">RS — Serbia</option>
				        <option value="RU">RU — Rusia</option>
				        <option value="RW">RW — Ruanda</option>
				        <option value="SA">SA — Arabia Saudí</option>
				        <option value="SB">SB — Islas Salomón</option>
				        <option value="SC">SC — Seychelles</option>
				        <option value="SD">SD — Sudán</option>
				        <option value="SE">SE — Suecia</option>
				        <option value="SG">SG — Singapur</option>
				        <option value="SI">SI — Eslovenia</option>
				        <option value="SK">SK — Eslovaquia</option>
				        <option value="SL">SL — Sierra Leona</option>
				        <option value="SM">SM — San Marino</option>
				        <option value="SN">SN — Senegal</option>
				        <option value="SO">SO — Somalia</option>
				        <option value="SR">SR — Surinam</option>
				        <option value="SS">SS — Sudán del Sur</option>
				        <option value="ST">ST — Santo Tomé y Príncipe</option>
				        <option value="SV">SV — El Salvador</option>
				        <option value="SY">SY — Siria</option>
				        <option value="SZ">SZ — Esuatini</option>
				        <option value="TD">TD — Chad</option>
				        <option value="TG">TG — Togo</option>
				        <option value="TH">TH — Tailandia</option>
				        <option value="TJ">TJ — Tayikistán</option>
				        <option value="TL">TL — Timor Oriental</option>
				        <option value="TM">TM — Turkmenistán</option>
				        <option value="TN">TN — Túnez</option>
				        <option value="TO">TO — Tonga</option>
				        <option value="TR">TR — Turquía</option>
				        <option value="TT">TT — Trinidad y Tobago</option>
				        <option value="TV">TV — Tuvalu</option>
				        <option value="TZ">TZ — Tanzania</option>
				        <option value="UA">UA — Ucrania</option>
				        <option value="UG">UG — Uganda</option>
				        <option value="US">US — Estados Unidos</option>
				        <option value="UY">UY — Uruguay</option>
				        <option value="UZ">UZ — Uzbekistán</option>
				        <option value="VA">VA — Ciudad del Vaticano</option>
				        <option value="VC">VC — San Vicente y las Granadinas</option>
				        <option value="VE">VE — Venezuela</option>
				        <option value="VN">VN — Vietnam</option>
				        <option value="VU">VU — Vanuatu</option>
				        <option value="WS">WS — Samoa</option>
				        <option value="XK">XK — Kosovo</option>
				        <option value="YE">YE — Yemen</option>
				        <option value="ZA">ZA — Sudáfrica</option>
				        <option value="ZM">ZM — Zambia</option>
				        <option value="ZW">ZW — Zimbabue</option>
				      </select>
				    </div>
				  )}
				  <div className="form-group">
				    <label htmlFor="verifactu_territorio_fiscal">Territorio fiscal (Verifactu)</label>
				    <select className="form-control" id="verifactu_territorio_fiscal" name="verifactu_territorio_fiscal"
				      value={this.state.client?.verifactu_territorio_fiscal || 'ES'}
				      onChange={this.handleChange}>
				      <option value="ES">España (Península, Baleares, Canarias, Ceuta y Melilla)</option>
				    </select>
				  </div>
				  <div className="form-group">
				    <label htmlFor="complete_direction">{this.getTrad("completeDirection")}</label>
				    <input type="text" className="form-control" id="complete_direction" name="complete_direction"
				    defaultValue={this.state.client?this.state.client.complete_direction:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
						<label htmlFor="location">Delegación</label>
						<select className="form-control" id="location" name="location"
						defaultValue={this.state.client?this.state.client.location:''} onChange={this.handleChange}>
							<option value ='' selected={this.state.client?.location?.length>4?true:undefined}>Seleccione una opción</option>
							{this.state.locations?.map(loc => {
								return <option key={loc._id} value={loc._id} selected={String(this.state.client?.location) === String(loc._id)?true:undefined}>
									{loc.name}
								</option>
							})}
						</select>
					</div>
				  <div className="form-group">
				  	<label data-toggle="collapse" 
				  	data-target="#contactModesTab" aria-expanded="false" aria-controls="contactModesTab" style={this.expandTab}>
				      		Modos de contacto
				        </label>
				  </div>
				  <div className="collapse" id="contactModesTab">
				  	{this.renderContactModes()}
				  </div>
				  <div className="form-group">
				    <label htmlFor="comments">{this.getTrad("comments")}</label>
				    <textarea className="form-control" id="comments" name="comments"
				    defaultValue={this.state.client?this.state.client.comments:''} 
				    onChange={this.handleChange}></textarea>
				  </div>
				</form>
			</div>
                </div>
		{/*Final tab Principal*/}

		{/*Comienzo tab citas*/}
		<div className="row mt-4 mb-3" id="citas" style={{display:'none'}}>
			<div className="col-12">

				{
					
				this.state.schedules?this.state.schedules.map((schedule,idx) => {
					let color = '';
					let status = '';
					switch(schedule.status){
						case 3:
							//Reportado como cancelada
							status = 'Cancelado';
							color = 'secondary';
							break;
						case 2:
							//Reportado como finalizada
							status = 'Finalizado';
							color = 'success';
							break;
						case 1:
						default:
							color = 'info';
							status = 'Planificado';
							let date = new Date();
							let scheduleDate = new Date(schedule.end_date);
							const hoursFromTimezoneOffset = (date.getTimezoneOffset()*-1) / 60;

							scheduleDate.setHours(scheduleDate.getHours()-hoursFromTimezoneOffset);

							if(date.getTime() >= scheduleDate.getTime()){
								color = 'danger';
								status = 'No reportado';
							}
							break;
					}
					return (<div className={"card w-100 mb-2 border-"+color} key={'schedule_'+schedule._id}
						onClick={() => this.openScheduleCard(idx)} style={this.cursorPointer}>
						<div className="card-body">
							<h5 className="card-title">
								{schedule.title} 
								<span className={"badge ml-3 badge-"+color}>{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{schedule.formatted_start_date}</h6>
							<p className="card-text">Usuario: {schedule.assigned_user.name+' '+schedule.assigned_user.lastname}</p>
							<p className="card-text ">{schedule.description}</p>
						</div>
					</div>);
				}):''}

			</div>
		</div>
		{/*Final tab citas*/}

		{/*Comienzo tab ficheros*/}
		<div className="row mt-4 mb-3" id="ficheros" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

					  <button type="button" className="btn btn-primary mb-2" onClick={this.showAddFileWindow}>Nuevo fichero</button>

			{this.state.files && this.state.files.length>0?this.state.files.map((file,idx) => {
					return (<div className="card w-100 mb-2 border-secondary" key={'file_'+file._id}> 
						<div className="card-body">
							<h5 className="card-title">
								{file.name}
								<span onClick={() => {this.downloadFile(file._id)}} className={"badge ml-3 badge-primary"} style={{cursor:'pointer'}}>Descargar</span>
								<span onClick={() => {this.deleteFile(file._id)}} className={"badge ml-3 badge-secondary"} style={{cursor:'pointer'}}>Eliminar</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{this.formatDateToUserString(file.creation_date)}</h6>
							<p className="card-text">Usuario: {file.created_by_user.name+' '+file.created_by_user.lastname} </p>
							<p className="card-text ">{file.comments}</p>
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay ficheros para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab ficheros*/}

		{/*Comienzo tab facturas*/}
		<div className="row mt-4 mb-3" id="facturas" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

			{this.state.bills && this.state.bills.length>0?this.state.bills.map((bill,idx) => {
					let status = '';
					switch(parseFloat(bill.status)){
						case 1:
							status = this.getTrad("pendingBillStatus")
							break
						case 2:
							status = this.getTrad("overdueBillStatus")
							break
						case 3:
							status = this.getTrad("collectedBillStatus")
							break
						case 4:
							status = this.getTrad("unpaidBillStatus")
							break
						case 5:
							status = this.getTrad("returnedPayBillStatus")
							break
						default: status = 'Desconocido'
					}

					return (<div className="card w-100 mb-2 border-secondary" key={'bill_'+bill._id}> 
						<div className="card-body" onClick={() => {this.openBill(bill._id)}} style={{cursor:'pointer'}}>
							<h5 className="card-title">
								{bill.type === 1?'Factura':'Factura rectificativa'}
								<span className={"badge ml-3 badge-secondary"} >{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{this.formatDateToUserString(bill.creation_date)}</h6>
							<p className="card-text">Código de factura: {bill.code}</p>
							<p className="card-text">Precio total: {bill.total_price+' €'}</p>
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay facturas para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab facturas*/}


		{/*Comienzo tab articulos*/}
		<div className="row mt-4 mb-3" id="articulos" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

			
			{this.state.articles && this.state.articles.length>0?this.state.articles.map((article,idx) => {
				let status = ''
				let bookingStartDate = ''
				let bookingEndDate = ''
				let bookingFound = false

				let billCode = undefined

				let foundBills = []
				this.state.bills?.forEach(bill => {
					let foundArticles = bill.lines?.filter(line => line.article === article._id)
					if(foundArticles.length > 0) foundBills.push(bill)
				})

				if(foundBills.length >= 1) billCode = foundBills[foundBills.length-1].code

				const now = new Date()
				article.bookings.forEach(bk => {
					if(!bookingFound && (bk.booking_status === 5 || 
						(now.getTime() <= new Date(bk.end_date) && now.getTime() >= new Date(bk.start_date))
						)){
						bookingFound = true
						status = bk.booking_status
						bookingStartDate = bk.start_date
						bookingEndDate = bk.end_date
					}
				})

					switch(parseFloat(status)){
						case 1: status = this.getTrad("availableStatus");break
						case 2: status = this.getTrad("occupedStatus");break
						case 3: status = this.getTrad("repairingStatus");break
						case 4: status = this.getTrad("rentedStatus");break
						case 5: status = this.getTrad("soldStatus");break
						default: status = 'Desconocido'
					}

					return (<div className="card w-100 mb-2 border-secondary" key={'bill_'+article._id}> 
						<div className="card-body" onClick={() => {this.openArticle(article._id)}} style={{cursor:'pointer'}}>
							<h5 className="card-title">
								{article.name}
								<span className={"badge ml-3 badge-secondary"}>{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">
							{parseFloat(article.status) === 5?"Fecha venta":"Fecha inicio"}: {this.formatDateToUserString(bookingStartDate)}
							</h6>
							{parseFloat(article.status) !== 5 && 
								<h6 className="card-subtitle mb-2 text-muted">
									Fecha fin: {this.formatDateToUserString(bookingEndDate)}
								</h6> 
							}
							<p>Factura: {billCode?billCode:'Sin factura asociada'}</p>
							
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay artículos para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab articulos*/}



		<div className="row">
			<div className="col-12">
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>{this.state.isSaving ? 'Guardando...' : 'Guardar'}</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>

			</div>
		</div>


		<div className="modal fade" id="editSchedule" tabIndex="-1" role="dialog" aria-labelledby="editScheduleTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="editScheduleTitleLabel">
							{this.getTrad('scheduleInfo')}
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						{this.renderEditSchedule()}
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-primary" data-dismiss="modal"
							onClick={() => {
								const api = this.getApi();
								let schToApi = this.state.scheduleSelected;
								schToApi.assigned_user = schToApi.assigned_user._id;
								api.updateSchedule(schToApi, this.changeScheduleCallback);
								$("#editSchedule").modal('toggle');
								
							}}>
							{this.getTrad("Aceptar")}
						</button>
						<button type="button" className="btn btn-secondary" data-dismiss="modal"
							onClick={() => {
								$("#editSchedule").modal('toggle');
								
							}}>
							{this.getTrad("Cancelar")}
						</button>

					</div>
				</div>
			</div>
		</div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer'
    }

    expandTab = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }

}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        clients: state.clients
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        },
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditClient)
